export default __webpack_public_path__ + "health-picked-942bcca62a0cd36449d9d1842e2b02ae.wav";